export default "/images/vendor/flag-icon-css/flags/1x1/is.svg?1842f1a952e8f0d4ca471d3cd3872b2a";